import type { SVGProps } from 'react';
const SvgZoomDocumentStreamlineCore = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <desc>{'Zoom Document Streamline Icon: https://streamlinehq.com'}</desc>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M5.946 15.196H1.982c-.73 0-1.321-.591-1.321-1.321V1.982c0-.73.591-1.321 1.321-1.321h10.572c.73 0 1.321.591 1.321 1.321v3.964M3.964 4.625H7.93M3.964 7.929h2.643" />
      <path d="M12.554 16.518a3.964 3.964 0 1 0 0-7.929 3.964 3.964 0 0 0 0 7.929M17.84 17.84l-2.313-2.313" />
    </g>
  </svg>
);
export default SvgZoomDocumentStreamlineCore;
